module.exports = __webpack_public_path__ + "img/Solapur2.7af73cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/Solapur/Solapur2.jpg
// module id = 1815
// module chunks = 1